<template>
  <div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <div slot="header">
        <span>根据商品编号生成直链</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="18" :offset="0">
            <el-input
        type="textarea"
        :rows="2"
        v-model="skus"
        placeholder="多个商品编号用英文逗号','分隔"
        :maxlength="-1"
        :show-word-limit="false"
        :autosize="{ minRows: 2, maxRows: 4 }"
      >
      </el-input>
        </el-col>
        <el-col :span="6" :offset="0">
            <el-button type="primary" size="small" @click="genConfirm">生成</el-button>
            
        </el-col>
      </el-row>
      
      <div v-for="(item, index) in confirms" :key="index">
        <p style="margin: 15px auto;">{{item.confirmUrl}} <el-button type="primary" size="mini" @click="copy(item.confirmUrl)">复制</el-button>
        </p>
        <img :src=item.imgStream></img>
      </div>
    </el-card>
  </div>
</template>

<script>
import { genConfirm } from "@/api/jdDoubleProduct";
export default {
  data() {
    return {
      skus: undefined,
      confirms: [],
    };
  },
  created() {},
  mounted() {},
  methods: {
    genConfirm() {
      genConfirm(this.skus).then((res) => {
        this.confirms = res.data;
      });
    },
    copy(val){
       let oInput = document.createElement("input");
        oInput.value = val;
        document.body.appendChild(oInput);
        oInput.select();
        document.execCommand("Copy");
        oInput.remove();
        this.$message.success("复制成功!"); 
    }
  },
};
</script>

<style>
</style>
